<div class="wgu-container">
  <h2>Update Account</h2>

  <div class="my-6"></div>

  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3">
    <div class="card">
      <img
        alt="Update Account"
        class="img-responsive"
        src="/assets/images/updateAccount/Lock.png"
        width="56"
      />

      <p class="card-title">Update your Account.</p>

      <p class="mb-6">Update your security questions and other account information.</p>

      <button class="card-action" (click)="authenticationQuestions()">Update</button>
    </div>
  </div>
</div>
